import { Component } from '@angular/core';
import { PlatformService } from 'src/app/shared/services/platform.service';

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss']
})
export class JobComponent {
  renderer: any;

  constructor(private platformService: PlatformService) {}

  isServer() {
    return this.platformService.isPlatformServer();
  }
}
